export default {
  client: [
    {
      order: 1,
      label: 'Guest ID',
      dataKey: 'client.id',
      width: 80
    },
    {
      order: 1,
      label: 'Guest Name',
      dataKey: 'client.name',
      width: 200
    }
  ],
  householdTotal: {
    order: 1,
    label: 'Total Individual',
    dataKey: 'householdTotal',
    width: 130
  },
  trackingMethod: [
    {
      order: 2,
      label: 'Tracking Method ID',
      dataKey: 'trackingMethod.id',
      width: 150
    },
    {
      order: 2,
      label: 'Tracking Method Name',
      dataKey: 'trackingMethod.name',
      width: 200
    }
  ],
  inventoryLocation: [
    {
      order: 3,
      label: 'Location ID',
      dataKey: 'inventoryLocation.id',
      width: 96
    },
    {
      order: 3,
      label: 'Location Name',
      dataKey: 'inventoryLocation.name',
      width: 200
    }
  ],
  item: [
    {
      order: 4,
      label: 'Item ID',
      dataKey: 'item.id',
      width: 80
    },
    {
      order: 4,
      label: 'Item Name',
      dataKey: 'item.name',
      width: 200
    }
  ],
  quantity: {
    order: 5,
    label: 'Quantity',
    dataKey: 'quantity',
    width: 100
  },
  weight: {
    order: 6,
    label: 'Weight',
    dataKey: 'weight',
    width: 100
  },
  points: {
    order: 7,
    label: 'Points',
    dataKey: 'points',
    width: 100
  },
  price: {
    order: 8,
    label: 'Price',
    dataKey: 'price',
    width: 100
  }
};
